import { Formik, Form } from "formik";
import * as Yup from "yup";
import PrimaryModal from "../UI/Modal/PrimaryModal";
import { FormikInput, PrimaryButton, SecondaryButton } from "../UI";
import { useState } from "react";
import { toast } from "react-toastify";
import { useUserContext } from "../../contexts/UserContext";
import { manualTopup } from "../../utils/APIs";

const manualTopupSchema = Yup.object().shape({
    credits: Yup.number()
        .required("Credits are required")
        .positive("Credits must be a positive number")
        .integer("Credits must be an integer")
        .max(100, "Maximum 100 credits can be added at a time"),
});

const ManualTopupModal = ({ setSelectedAction, selectedMapping, getMappings }) => {
    const [submitError, setSubmitError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { userData } = useUserContext();

    const initialValues = {
        credits: 0,
    };

    const handleSubmit = async (values, actions) => {
        setIsSubmitting(true);
        try {
            const result = await manualTopup(userData?.token, userData?.selectedOrganization?.org_token, {
                orgId: selectedMapping.org_id,
                credits: values.credits,
            });
            if (result.status) {
                toast.success(result.message);
                getMappings();
                actions.resetForm();
                setSubmitError("");
                setSelectedAction("");
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Failed to add credits. Please try again.";
            setSubmitError(errorMessage);
            toast.error(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <PrimaryModal title={`Add Manual Credits - ${selectedMapping.org_name}`} hideModal={() => setSelectedAction("")}>
            <Formik
                initialValues={initialValues}
                validationSchema={manualTopupSchema}
                onSubmit={handleSubmit}
            >
                {() => (
                    <Form className="space-y-4 p-6">
                        <FormikInput
                            type="number"
                            id="credits"
                            name="credits"
                            label="Credits to Add"
                            placeholder="Enter amount of credits"
                        />

                        {submitError && <div className="text-red-500 text-sm mb-4">{submitError}</div>}

                        <div className="flex justify-end space-x-4">
                            <SecondaryButton type="button" handleClick={() => setSelectedAction("")}>
                                Cancel
                            </SecondaryButton>
                            <PrimaryButton type="submit" disabled={isSubmitting}>
                                {isSubmitting ? "Adding..." : "Add Credits"}
                            </PrimaryButton>
                        </div>
                    </Form>
                )}
            </Formik>
        </PrimaryModal>
    );
};

export default ManualTopupModal;
